
import { computed, defineComponent } from 'vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import Dropdowns from '@/modules/map-dropdowns/Dropdowns.vue';
import {} from 'vue3-google-map';
import { useStore } from 'vuex';
import { Getters, Mutations, store } from '@/store';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';

export default defineComponent({
    components: {
        ModalBody,
        ModalFooter,
        Dropdowns,
    },
    props: {
        details: null,
    },
    data() {
        return {
            modal: null,
            dropdownsCallback: [],
        };
    },
    setup() {
        const store = useStore();
        return { store };
    },
    mounted() {
        const modalElement = this.$refs.dataSourceLegend;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, 'xl');
        ModalService.open(this.modal);
        this.renderMap();
    },
    computed: {},
    methods: {
        toggleView() {
            const map = document.getElementById('map')!;
            const street = document.getElementById('street')!;
            const toggleButton = document.getElementById('toggleButton')!;

            if (map.getAttribute('hidden') !== null) {
                map.removeAttribute('hidden');
                street.setAttribute('hidden', 'true');
                toggleButton.classList.remove('btn-google-dark');
                toggleButton.classList.add('btn-google-light');
                toggleButton.textContent = 'Street View';
            } else {
                street.removeAttribute('hidden');
                map.setAttribute('hidden', 'true');
                toggleButton.classList.add('btn-google-dark');
                toggleButton.classList.remove('btn-google-light');
                toggleButton.textContent = 'Satellite View';
            }
        },
        renderMap() {
            const address = `${this.details.address.address1}, ${this.details.address.city}, ${this.details.address.state} ${this.details.address.zipCode}`;
            const noImageHtml = `<div class='container h-100'><div class='row h-100 justify-content-center align-items-center'><h3>No Street View Picture Available.</h3></div></div>`;
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: address }, function (results: any, status: any) {
                if (status === window.google.maps.GeocoderStatus.OK) {
                    const gps = results[0].geometry.location;
                    // Map View
                    const map = new window.google.maps.Map(document.getElementById('map') as HTMLElement);
                    const options = {
                        zoom: 20,
                        mapTypeId: 'satellite',
                        disableDefaultUI: true,
                        zoomControl: true,
                        fullscreenControl: true,
                        mapTypeControl: true,
                        rotateControl: true,
                        rotateControlOptions: {
                            position: window.google.maps.ControlPosition.RIGHT_CENTER,
                        },
                    };
                    map.setCenter(gps);
                    map.setOptions(options);
                    map.addListener('idle', function () {
                        // Show button
                        document.getElementById('toggleStreetView')!.removeAttribute('hidden');
                    });
                    // Street View - DirectionsService is deprecated; StreetViewService already
                    // resolves the nearest panorama within radius, so it doesn't need a road-snapped point.
                    const street = new window.google.maps.StreetViewPanorama(document.getElementById('street') as HTMLElement);

                    const service = new window.google.maps.StreetViewService();
                    service.getPanorama({ location: gps, radius: 50 }, function (panoData: any, status: any) {
                        if (status !== window.google.maps.StreetViewStatus.OK) {
                            document.getElementById('street')!.innerHTML = noImageHtml;
                            return;
                        }
                        const angle = window.google.maps.geometry.spherical.computeHeading(panoData.location.latLng, gps);
                        const panoOptions = {
                            position: gps,
                            pov: {
                                heading: angle,
                                pitch: 0,
                                zoom: 1,
                            },
                            disableDefaultUI: true,
                            zoomControl: true,
                            fullscreenControl: true,
                            enableCloseButton: false,
                            visible: true,
                        };

                        street.setOptions(panoOptions);
                    });
                } else {
                    document.getElementById('map')!.innerHTML = noImageHtml;
                    return;
                }
            });
        },
        DropdownsCallback(value: any) {
            this.dropdownsCallback = value;
        },
        async SaveData() {
            // Update Active comp source data values
            for (const idx in this.dropdownsCallback) {
                const field = this.dropdownsCallback[idx];
                for (var key of Object.keys(field)) {
                    if (key === 'fieldId' || key === 'fieldName' || field[key] === undefined) {
                        continue;
                    }

                    const comp = computed(() => store.getters[Getters.CompAddressesV36.ActiveComp]);
                    this.store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataValueByFieldName, {
                        comp: comp.value,
                        fieldName: field['fieldName'],
                        name: key,
                        value: field[key],
                    });
                }
            }

            ModalService.hide(this.modal);
        },
    },
});
